module.exports = __webpack_public_path__ + "img/GetItOnGooglePlay_Badge_Web_color_English.e6d552c5.png";